import { useState } from "react";
import axios from "axios";
import { Send, Loader2, CheckCircle2 } from "lucide-react";

const EMPTY = { nome: "", cognome: "", telefono: "", email: "", messaggio: "", website: "" };
const inp = "w-full rounded-xl border border-white/10 bg-white/[0.03] px-4 py-3 text-sm text-white placeholder:text-slate-500 focus:outline-none focus:border-amber-500/60 transition-colors";

// Form contatti del sito pubblico: invia una email al superadmin.
export const LandingContact = () => {
  const [f, setF] = useState(EMPTY);
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  const [err, setErr] = useState("");
  const set = (k) => (e) => setF((x) => ({ ...x, [k]: e.target.value }));
  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setBusy(true);
    try { await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/public/contatto`, f); setSent(true); setF(EMPTY); }
    catch (ex) { const d = ex?.response?.data?.detail; setErr(typeof d === "string" ? d : "Invio non riuscito. Controlla i dati e riprova."); }
    finally { setBusy(false); }
  };
  return (
    <section id="contatti" className="py-24 sm:py-28 bg-[#0c1019] border-y border-white/5" data-testid="landing-contact">
      <div className="mx-auto max-w-3xl px-5 sm:px-8">
        <h2 className="font-head text-3xl sm:text-4xl font-bold text-white">Contattaci</h2>
        <p className="mt-3 text-base md:text-lg text-slate-400">Vuoi saperne di più su PatroGestPro? Scrivici e ti ricontatteremo.</p>
        {sent ? (
          <div className="mt-8 flex items-start gap-3 rounded-2xl border border-emerald-500/30 bg-emerald-500/10 p-5 text-emerald-200" data-testid="contact-success">
            <CheckCircle2 className="h-5 w-5 shrink-0 mt-0.5" />
            <div><div className="font-semibold">Messaggio inviato</div><div className="text-sm text-emerald-200/80">Grazie, ti risponderemo al più presto.</div>
              <button type="button" onClick={() => setSent(false)} data-testid="contact-new" className="mt-2 text-sm underline">Invia un altro messaggio</button></div>
          </div>
        ) : (
          <form onSubmit={submit} className="mt-8 grid sm:grid-cols-2 gap-4" data-testid="contact-form">
            <input required maxLength={80} value={f.nome} onChange={set("nome")} placeholder="Nome *" className={inp} data-testid="contact-nome" />
            <input required maxLength={80} value={f.cognome} onChange={set("cognome")} placeholder="Cognome *" className={inp} data-testid="contact-cognome" />
            <input type="tel" maxLength={40} value={f.telefono} onChange={set("telefono")} placeholder="Telefono" className={inp} data-testid="contact-telefono" />
            <input required type="email" value={f.email} onChange={set("email")} placeholder="Email *" className={inp} data-testid="contact-email" />
            <textarea required maxLength={5000} rows={5} value={f.messaggio} onChange={set("messaggio")} placeholder="Messaggio *" className={`${inp} sm:col-span-2 resize-y`} data-testid="contact-messaggio" />
            <input tabIndex={-1} autoComplete="off" value={f.website} onChange={set("website")} className="hidden" aria-hidden="true" />
            {err && <p className="sm:col-span-2 text-sm text-red-300" role="alert" data-testid="contact-error">{err}</p>}
            <div className="sm:col-span-2">
              <button type="submit" disabled={busy} data-testid="contact-submit" className="inline-flex items-center gap-2 rounded-full bg-amber-500 hover:bg-amber-400 px-7 py-3.5 text-sm font-semibold text-[#0a0d14] transition-colors disabled:opacity-60">
                {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Send className="h-4 w-4" />} Invia messaggio
              </button>
            </div>
          </form>
        )}
      </div>
    </section>
  );
};
